import produce from 'immer';
import { FARM_NOTIFICATION, FARM_NOTIFICATION_REQUEST, NOTIFICATION_CONFIG_SAVING } from '../constants/action-types';

const initialState = {
    isRequesting: false,
    isSaving: false,
    configuration: {
        enabled: false,
        semi_max_speed: {
            value: 0,
            enabled: false
        },
        truck_max_speed: {
            value: 0,
            enabled: false
        },
        pto_rpm_max_speed: {
            value: 0,
            enabled: false
        },
        engine_rpm_max_speed: {
            value: 0,
            enabled: false
        },
        idle_equipment_max_time: {
            value: 0,
            enabled: false
        }
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FARM_NOTIFICATION_REQUEST:
            state = produce(state, s => {
                s.isRequesting = action.payload;
            });
            break;
        case FARM_NOTIFICATION:
            state = produce(state, s => {
                s.configuration = action.payload;
                s.isRequesting = false;
            });
            break;
        case NOTIFICATION_CONFIG_SAVING:
            state = produce(state, s => {
                s.isSaving = action.payload;
            });
            break;
        default:
            break;
    }
    return state;
};